import React from "react";
import { useRouteError, useNavigate } from "react-router-dom";
import styles from "./ErrorPage.module.css";
import { useLanguage } from "../../contexts/language/LanguageContext";


const ErrorPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  // React Router hook to catch the specific error thrown
  const error = useRouteError();
  console.error(error); // Log error to console for developers

  // Check if it's a 404 error
  const is404 = error?.status === 404 || error?.statusText === "Not Found";

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* --- Icon / Illustration --- */}
        <div className={styles.errorCode}>
          {is404 ? "404" : ":("}
        </div>

        {/* --- Title --- */}
        <h1 className={styles.title}>
          {is404 ? t("error_title_404") : t("error_title_general")}
        </h1>

        {/* --- Description --- */}
        <p className={styles.message}>
          {is404 ? t("error_msg_404") : t("error_msg_general")}
        </p>

        {/* --- Technical Details (Optional: Show only for general errors) --- */}
        {!is404 && error && (
          <div className={styles.errorDetails}>
            <strong>{t("error_details")}</strong>
            <pre>
              {error.statusText || error.message}
            </pre>
          </div>
        )}

        {/* --- Back Button --- */}
        <button 
          className={styles.homeButton} 
          onClick={() => navigate("/")}
        >
          {t("error_btn_home")}
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;